import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "inventoryconfigurationapi-module"
    }}>{`InventoryConfigurationApi module`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`InventoryConfigurationApi`}</inlineCode>{` module provides service contracts for inventory management configuration.`}</p>
    <p>{`This module is part of the new inventory infrastructure. The
`}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/rest/inventory/index.html"
      }}>{`Inventory Management overview`}</a>{`
describes the MSI (Multi-Source Inventory) project in more detail.`}</p>
    <h2 {...{
      "id": "installation-details"
    }}>{`Installation details`}</h2>
    <p>{`This module is installed as part of Magento Open Source. It cannot be disabled.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`InventoryConfigurationApi`}</inlineCode>{` module contains extension points and APIs that 3rd-party developers
can use to provide custom inventory functionality.`}</p>
    <h3 {...{
      "id": "public-apis"
    }}>{`Public APIs`}</h3>
    <p>{`Public APIs are defined in the `}<inlineCode parentName="p">{`Api`}</inlineCode>{` and `}<inlineCode parentName="p">{`Api/Data`}</inlineCode>{` directories.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 1.2.4.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      